import { Loading } from '@/components/ui/Loading';
import { useAuthInit } from '@/hooks/useAuth';
import { ReactNode } from 'react';

interface AuthProviderProps {
  children: ReactNode;
}

/**
 * Provider d'authentification qui initialise l'auth au démarrage
 * et charge automatiquement le profil utilisateur si connecté
 */
export const AuthProvider = ({ children }: AuthProviderProps) => {
  const { isLoading } = useAuthInit();

  // Afficher un loading pendant l'initialisation de l'auth
  if (isLoading) {
    return <Loading />;
  }

  return <>{children}</>;
};
